import { BillingInterval } from "enums/BillingInterval";

const PERIOD: Record<BillingInterval, string> = {
  [BillingInterval.WEEKLY]: "week",
  [BillingInterval.BIWEEKLY]: "2 weeks",
  [BillingInterval.MONTHLY]: "month",
  [BillingInterval.QUARTERLY]: "3 months",
  [BillingInterval.SEMIANNUALLY]: "6 months",
  [BillingInterval.YEARLY]: "year",
};

const CADENCE: Record<BillingInterval, string> = {
  [BillingInterval.WEEKLY]: "Every week",
  [BillingInterval.BIWEEKLY]: "Every 2 weeks",
  [BillingInterval.MONTHLY]: "Every month",
  [BillingInterval.QUARTERLY]: "Every 3 months",
  [BillingInterval.SEMIANNUALLY]: "Every 6 months",
  [BillingInterval.YEARLY]: "Every year",
};

const SUFFIX: Record<BillingInterval, string> = {
  [BillingInterval.WEEKLY]: "/wk",
  [BillingInterval.BIWEEKLY]: "/2wk",
  [BillingInterval.MONTHLY]: "/mo",
  [BillingInterval.QUARTERLY]: "/qtr",
  [BillingInterval.SEMIANNUALLY]: "/6mo",
  [BillingInterval.YEARLY]: "/yr",
};

const asInterval = (interval?: string | null): BillingInterval =>
  interval && interval in PERIOD
    ? (interval as BillingInterval)
    : BillingInterval.MONTHLY;

export const intervalPeriod = (interval?: string | null): string =>
  PERIOD[asInterval(interval)];

export const intervalCadence = (interval?: string | null): string =>
  CADENCE[asInterval(interval)];

export const intervalSuffix = (interval?: string | null): string =>
  SUFFIX[asInterval(interval)];

export const intervalOptions = (): { id: BillingInterval; label: string }[] =>
  (Object.keys(CADENCE) as BillingInterval[]).map((id) => ({
    id,
    label: CADENCE[id],
  }));
